module.exports = __webpack_public_path__ + "static/media/IoTFlowsLogoBlackFont.39c44973.png";